import { Operation } from 'hooks/store/types';
import { ActionTypes, resetAdminUserMFA } from 'store/account/admin';
import { useEffect } from 'react';
import { useDispatch, usePrevious } from 'hooks/utils';
import { useTranslation } from 'hooks/store';
import { useActivity } from 'hooks/store/utils/useActivity';
import { useAlerts } from 'hooks/ui';

export function useAdminUserMFAReset(): Operation {
	const dispatch = useDispatch();
	const { translate } = useTranslation();
	const { setNotification } = useAlerts();

	const [{ loading, error }] = useActivity(ActionTypes.ADMIN_RESET_USER_MFA);

	const wasLoading = usePrevious(loading);
	useEffect(() => {
		if (wasLoading && !loading && !error) {
			setNotification({
				message: translate(({ admin }) => admin.users.notifications.resetMFA)
			});
		}
	}, [loading, error]);

	function handler() {
		dispatch(resetAdminUserMFA());
	}

	return [{ loading, error }, handler];
}
